<div class="custom-assignment-dropdown" [class.open]="isDropdownOpen">
  <div class="dropdown-header" (click)="toggleDropdown()">
    {{ selected || 'Select' }}
    <span class="arrow" [class.rotated]="isDropdownOpen">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.862 6.19531L7.99998 9.05731L5.13798 6.19531L4.19531 7.13798L7.99998 10.9426L11.8046 7.13798L10.862 6.19531Z"
          fill="#6B6D71" />
      </svg>
    </span>
  </div>

  <ul *ngIf="isDropdownOpen" class="dropdown-list" (click)="$event.stopPropagation()">
    <li *ngFor="let option of options" (click)="selectAssignment(option)">
      {{ option }}
    </li>
  </ul>
</div>